import HttpService from "./HttpService";
import store from "../store/store";

const sdkHost = 'https://document.brscan.com.br';
const V_INIT = '/v1';



export default class UploadDocDigitalService  extends HttpService{
    constructor(props) {
        super(props);
    }
     async validaChave(){
        this.$store = store;
        try {
            const formData = new FormData();
            formData.append('key', this.$store.state.chave);
            formData.append('version', '3.0.0');
            formData.append('api_level', '1');
            formData.append('model', 'web');
            formData.append('os', 'web');
            return await this._post(sdkHost + V_INIT + '/mobile/sdk-licenca', formData,{'Content-Type': 'multipart/form-data'});
        }catch (e) {
            console.log(e);
            return false;
        }
    }

     async buscarToken(sdkAuth,sdkLicence){
        try {
            let data = await this._post(sdkHost + V_INIT + '/init/' + sdkLicence,null,{'Authorization': 'basic ' + sdkAuth});
            if (data.error) {
                console.log(data.error);
                return false;
            } else {
                return data.token;
            }
        } catch (ex) {
            console.log(ex);
            return false;
        }
    }

     async enviaDocumento(file,sdkToken,sdkLicence,sdkAuth, tipoDocumento) {
        this.$store = store;
        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('key', this.$store.state.chave);
            formData.append('version', '3.0.0');
            formData.append('api_level', '1');
            formData.append('model', 'web');
            formData.append('os', 'web');
            let data = await this._post(sdkHost + V_INIT + '/type-document/' + sdkLicence,formData,
            {'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + sdkToken}
            );
            
            let validationDoc = data.documento;

            if (validationDoc === undefined) {
                return false;
            }

            if (!validationDoc.includes(tipoDocumento.toLowerCase())) {
                return false;
            }

        } catch (err) {
            console.log(err)
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/UploadDocDigitalService.js